import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";
import { tratarMensagemDeErro } from "../helper/helper";


export const AjustarFeriasService = {
  async getById(id) {
    const response = await BaseService.fetchResponseFromAPIGet(`ajusteferias/justificarecusa/${id}`);
    if (response.error) {
      SnackBarModule("Houve um erro ao consultar as informações deste item", "error");
    }
    return response.content;
  },

  async ajustarFerias(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      `ajusteferias`,
      postData,
    );
    if (response.error) {
      SnackBarModule(tratarMensagemDeErro(response.message), "error");
      return false;
    }
    SnackBarModule("Ajuste de férias enviado com sucesso.", "success");
    return true;
  },
}